import { createContext, useContext, ReactNode } from "react";
import { useOnboardingChecklist } from "hooks/useOnboardingChecklist";

type OnboardingChecklistContextValue = ReturnType<typeof useOnboardingChecklist>;

const OnboardingChecklistContext =
  createContext<OnboardingChecklistContextValue | null>(null);

export function OnboardingChecklistProvider({
  condoId,
  children,
}: {
  condoId: number | null;
  children: ReactNode;
}) {
  const value = useOnboardingChecklist(condoId);
  return (
    <OnboardingChecklistContext.Provider value={value}>
      {children}
    </OnboardingChecklistContext.Provider>
  );
}

export function useOnboardingChecklistContext(): OnboardingChecklistContextValue {
  const ctx = useContext(OnboardingChecklistContext);
  if (!ctx) {
    throw new Error(
      "useOnboardingChecklistContext must be used within OnboardingChecklistProvider"
    );
  }
  return ctx;
}
